import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const BASE_INPUT_PROPS = {
  GridProps: {
    sx: 12,
    sm: 6,
  },
  InputProps: {
    sx: {
      width: '100%',
      height: 40,
      '&.Mui-readOnly': {
        boxShadow: 'unset',
        top: -10,
      },
      '&.Mui-readOnly .MuiSelect-icon': {
        color: 'transparent',
      },
      '&.Mui-readOnly .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
    },
  },

  HelperTextProps: {
    sx: {
      display: 'none',
    },
  },
  placeholder: '---',
};

export const FIELDS = [
  {
    label: 'HTF Affordability Period Start Date',
    name: 'HTFAffordabilityPeriodStartDate',
    variant: 'date',
    ...BASE_INPUT_PROPS,
  },

  {
    label: 'HTF Unit Type',
    name: 'HTFUnitType',
    variant: 'singleSelect',
    options: [
      {
        text: <FormattedMessage {...messages.fixed} />,
        value: messages.fixed.defaultMessage,
      },
      {
        text: <FormattedMessage {...messages.floating} />,
        value: messages.floating.defaultMessage,
      },
    ],
    ...BASE_INPUT_PROPS,
  },
];
